
(function () {
  var header = document.querySelector('[data-nextrobo-header]');
  if (!header) return;

  function updateHeader() {
    if (window.scrollY > 8) header.classList.add('is-scrolled');
    else header.classList.remove('is-scrolled');
  }

  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });

  document.addEventListener('click', function (event) {
    document.querySelectorAll('.nr-mobile-nav[open]').forEach(function (menu) {
      if (!menu.contains(event.target)) menu.removeAttribute('open');
    });
  });
})();
